import React from 'react';
import RevealOnScroll from './RevealOnScroll';

interface PageHeroProps {
  title: string;
  subtitle: string;
  bgImage?: string;
}

const PageHero: React.FC<PageHeroProps> = ({ title, subtitle, bgImage }) => {
  return (
    <section className="relative pt-28 pb-10 md:pt-40 md:pb-24 bg-brand-900 overflow-hidden">
       {/* Abstract Background Shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        {bgImage && (
            <>
            <img src={bgImage} alt="Background" className="absolute inset-0 w-full h-full object-cover opacity-20" />
            <div className="absolute inset-0 bg-brand-900/80 mix-blend-multiply"></div>
            </>
        )}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <RevealOnScroll>
          <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-3 md:mb-4 tracking-tight">
            {title}
          </h1>
          <p className="text-base md:text-xl text-brand-100 max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        </RevealOnScroll>
      </div>
    </section>
  );
};

export default PageHero;